import React from 'react';

const UploadSection = ({ fileInputRef, handleImageSelect }) => {
  return (
    <input
      ref={fileInputRef}
      type="file"
      accept="image/*"
      multiple
      onChange={handleImageSelect}
      className="hidden"
    />
  );
};

export default UploadSection;
